module.exports = __webpack_public_path__ + "static/media/PlusGrey.784aacf5.svg";